var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FFFBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7558 43.25H39.2026C39.9077 43.25 40.4792 42.6743 40.4792 41.9643V38.5296C40.4792 38.2552 40.392 37.9879 40.2304 37.767L36.549 32.7351C36.2269 32.2949 36.2165 31.6977 36.5231 31.2464L39.9371 26.2211C40.0823 26.0073 40.1601 25.7542 40.1601 25.4951V22.0357C40.1601 21.3256 39.5885 20.75 38.8835 20.75H26.7558C26.0508 20.75 25.4792 21.3256 25.4792 22.0357V25.4703C25.4792 25.7448 25.5665 26.012 25.7281 26.233L29.3893 31.2373C29.7212 31.6908 29.7212 32.3091 29.3893 32.7627L25.7281 37.767C25.5665 37.9879 25.4792 38.2552 25.4792 38.5296V41.9643C25.4792 42.6743 26.0508 43.25 26.7558 43.25Z",
    stroke: "#F6A723",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpent);
export default __webpack_public_path__ + "static/media/Spent.c00beadec20cd225af0102fa2803206e.svg";
export { ForwardRef as ReactComponent };